const getProofItemsCountLabel = (received?: number, amount?: number): string | null => {
  if (!amount) return null;
  return `${received ?? 0}/${amount}`;
};

export default getProofItemsCountLabel;
